import Lenis from 'lenis';
import gsap from "gsap";

if (viewport().width > 767) {

    const lenis = new Lenis({
        anchors: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    gsap.ticker.lagSmoothing(0);

    $('body').on('stop-lenis', function () {
        lenis.stop();
    }).on('start-lenis', function () {
        lenis.start();
    });
}
